import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import { useIsWindowWiderThan } from '@common/hooks';
import { NameDateOption } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/Options.styles';
import { gridTheme } from '@utils/grid';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

type PerDateRangeOption = RoomExtraOption & { name?: string; startDate?: string; endDate?: string };

const optionsForPerDateRange = (options: PerDateRangeOption[], isMobile: boolean) =>
  options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const labelDate = startDate === endDate ? startDate : `${startDate} - ${endDate}`;
    return {
      label: isMobile ? (
        `${labelDate}: ${option.name}`
      ) : (
        <NameDateOption>
          <strong>{option.name}</strong> {labelDate}
        </NameDateOption>
      ),
      value: index,
    };
  });

type SelectOption = { label: string | JSX.Element; value: number };

export const PerDateRange = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const isMobile = !useIsWindowWiderThan(gridTheme.breakpoints.md);
  const opts = optionsForPerDateRange(options as PerDateRangeOption[], isMobile);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
